// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as CouponsApiModel from "../api-model/CouponsApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        coupon_code: e.coupon_code,
                        discount_amount: e.discount_amount,
                        validity: e.validity,
                        expired: e.expired,
                        message: e.message,
                        title: e.title,
                        short_description: e.short_description,
                        long_description: e.long_description,
                        auto_apply: e.auto_apply,
                        vehicle_ids: e.vehicle_ids
                      };
              }), data.offers);
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(CouponsApiModel.t_decode(json), "LocationBoundEntityMapper.res"));
}

export {
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
